import {
  computed,
  watch,
} from '@vue/composition-api';
import { mainStore, userStore } from 'partners-widget-core';
import useStore from '@/compositions/useStore';
import useRoute from '@/compositions/useRoute';

import useCampaigns from '@/compositions/ddm/useCampaigns';
import useCart from '@/compositions/ddm/useCart';
import useUser from '@/compositions/ddm/useUser';
import usePage from '@/compositions/ddm/usePage';
import useListing from '@/compositions/ddm/useListing';
import useWishList from '@/compositions/ddm/useWishList';
import useProductDetail from '@/compositions/ddm/useProductDetail';
import useSubscription from '@/compositions/ddm/useSubscription';
import useTransaction from '@/compositions/ddm/useTransaction';
import { MAIN_REGIONS } from '@/utils/constants/globalConst';

const useDigitalDataManager = () => {
  const { state } = useStore();
  const route = useRoute();
  const { addCampaigns } = useCampaigns();
  const { updateCart, setCart, resetCart } = useCart();
  const { changeUser, transformUser } = useUser();
  const { viewPage } = usePage();
  const { changeListing, clearListing } = useListing();
  const { toggleFavorite } = useWishList();
  const { setDefaultProduct, clearProduct } = useProductDetail();
  const { addNewUserSubscription, addSubscription } = useSubscription();
  const { resetTransaction, setTransaction } = useTransaction();

  const city = userStore.store.location.cityName || MAIN_REGIONS.msk.name;
  const user = computed({
    get: () => state.user,
    set: () => {},
  });

  const setDefault = (typePlatform = 'desktop') => {
    window.digitalData = {
      version: '1.1.3',
      website: {
        currency: 'RUB',
        environment: mainStore.store.env.environment,
        language: 'ru',
        type: typePlatform,
      },
      context: {
        ip: state.userIp,
      },
      page: {
        type: 'content',
        category: 'Content',
      },
      user: transformUser(),
      cart: {
        currency: 'RUB',
        subtotal: 0,
        total: 0,
        lineItems: [],
      },
    };

    if (route.value.meta.ddm) {
      window.digitalData.page = { ...window.digitalData.page, ...route.value.meta.ddm };
    }

    if (city) {
      window.digitalData.website.region = city;
    }

    watch(
      () => user.value,
      value => changeUser(value),
      { immediate: false },
    );
  };

  return {
    setDefault,
    addCampaigns,
    setCart,
    updateCart,
    resetCart,
    changeUser,
    viewPage,
    changeListing,
    clearListing,
    toggleFavorite,
    setDefaultProduct,
    clearProduct,
    addNewUserSubscription,
    addSubscription,
    resetTransaction,
    setTransaction,
  };
};

export default useDigitalDataManager;
